import { YearHeading } from "../../../../src/data/articles/four-tcgs-in-magics-trench-coat/YearHeading.tsx";
import * as React from 'react';
export default {
  YearHeading,
  React
};